import { memo } from 'react';
import { Box, Flex, Grid, Text } from '@chakra-ui/react';

const OfficeInfo = ({ city, address, dotStyles = null }) => (
  <Grid
    templateColumns={{ laptop: '12px auto', xxm: '6px auto' }}
    templateRows={{ desktop: '34px auto', laptop: '28px auto', xxm: '22px auto' }}
    gap={{ laptop: '12px', xxm: '8px' }}
  >
    <Box
      borderRadius="full"
      placeSelf="center"
      boxSize={{ laptop: '12px', xxm: '6px' }}
      bgColor="bg.accent"
      {...dotStyles}
    />

    <Flex align="center" textStyle="h1" lineHeight={{ laptop: '140%', tablet: '120%' }}>
      {city}
    </Flex>

    <Text
      gridColumn={2}
      gridRow={2}
      textStyle="h3"
      color="#A7A9A5"
      fontSize={{ laptop: '16px', tablet: '12px' }}
      dangerouslySetInnerHTML={{ __html: address }}
    />
  </Grid>
);

export default memo(OfficeInfo);
